import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import PropagateLoader from "react-spinners/PropagateLoader"
import { trainingDetailsRes, trainingDetailsTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingDetails'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from 'react-tooltip'
import { useNavigate } from 'react-router-dom/dist'
import moment from 'moment'

export default function TrainingDetails() {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const details = useSelector(state => state.trainingDetails && state.trainingDetails.data && state.trainingDetails.data.data)
    const course_list = useSelector(state => state.trainingDetails && state.trainingDetails.data && state.trainingDetails.data.data && state.trainingDetails.data.data.course_list)
    const user_list = useSelector(state => state.trainingDetails && state.trainingDetails.data && state.trainingDetails.data.data && state.trainingDetails.data.data.user_list)
    const [loading, setLoading] = useState(false)
    // console.log(user_list)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const mergedMap = new Map()

    details && details.user_list && details.user_list.forEach((item) => mergedMap.set(item.vemp_code, { ...item }))
    details && details.lms_attendences && details.lms_attendences.forEach((item) => mergedMap.set(item.user_id, { ...mergedMap.get(item.user_id), item }))

    const mergedArray = Array.from(mergedMap.values())

    const [columnDefs_course, setColumnDefs_course] = useState([
        {
            headerName: 'IMAGE',
            field: 'cover_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REVISION',
            field: 'revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     field: 'ACTIONS',
        //     cellRenderer: params =>
        //         <div>
        //             <IoInformationCircleOutline  size={20} className='eye'
        //                 onClick={() => course_details(params)}
        //                 data-tooltip-id='details'
        //                 data-tooltip-content="Course Details!"
        //                 data-tooltip-place="bottom"
        //             />
        //             <FiRefreshCw size={20} className='edit ms-3'
        //                 onClick={() => edit_course(params)}
        //                 data-tooltip-id='revise'
        //                 data-tooltip-content="Revise Course!"
        //                 data-tooltip-place="bottom"
        //             />
        //             <BiArchiveIn size={20} className='archive ms-3'
        //                 onClick={() => archive_course(params)}
        //                 data-tooltip-id='archive'
        //                 data-tooltip-content="Archive!"
        //                 data-tooltip-place="bottom"
        //             />

        //             <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
        //             <Tooltip id='revise' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
        //             <Tooltip id='archive' style={{ backgroundColor: "rgb(255,193,7)", zIndex: '9', lineHeight: 'normal' }} />
        //         </div>,
        //     // cellRenderer: UserListAction,
        //     // cellRendererParams: {
        //     //     editModal: setEditVenue,
        //     //     modalLoading: setModalLoading,
        //     //     editForm: setEdit,
        //     // },
        //     // wrapText: true,
        //     autoHeight: true,
        // }
    ])

    const [columnDefs_user, setColumnDefs_user] = useState([
        {
            headerName: 'NAME',
            field: 'vemp_fname',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'vemp_company_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'vdepartment_name',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'DESIGNATION',
            field: 'vdesignation_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMAIL',
            field: 'vemail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PHONE NO.',
            field: 'vmobile_no',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ATTENDANCE',
            field: 'item.attendence_status',
            cellRenderer: params => params.value == 'present' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> : params.value == 'absent' ? <span className='badge text-bg-danger text-capitalize'>{params.value}</span> : <span className='badge text-bg-warning text-capitalize'>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => user_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="User Details!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // cellRenderer: UserListAction,
            // cellRendererParams: {
            //     editModal: setEditVenue,
            //     modalLoading: setModalLoading,
            //     editForm: setEdit,
            // },
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const user_details = (params) => {
        navigate('/user_report', { state: params.data })
    }

    const details_res = () => {
        if (trainingDetailsRes && trainingDetailsRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(trainingDetailsTodo(state.id)).then(() => details_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <Link to={"/training_list"}><span className='icon2'>Session List / </span></Link>
                    <span className='icon2'>Session Details</span>
                </div>

                <div className="row row-flex">
                    <div className="col-12 col-md-6">
                        <div className="wrapper-admin training_details match_height">
                            <h6 className='text-center'>Basic Training Information</h6>

                            <div className="d-flex justify-content-between align-items-center mt-4 mb-1">
                                <p>Training Name</p>
                                <span> {loading ? 'loading...' : details && details.training_title ? details.training_title : '-'} </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Training Type</p>
                                <span> {loading ? 'loading...' : details && details.lms_training_type && details.lms_training_type.training_type_title ? details.lms_training_type.training_type_title : '-'} </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Training Mode</p>
                                <span> {loading ? 'loading...' : details && details.training_mode ? details.training_mode : '-'} </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Instructor Name</p>
                                <span> {loading ? 'loading...' : details && details.instructor_name ? details.instructor_name : '-'} </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Classroom Type</p>
                                <span> {loading ? 'loading...' : details && details.classroom ? details.classroom : '-'} </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Start Date & Time</p>
                                <span> {loading ? 'loading...' : details?.start_date ? moment(details.start_date).format('DD/MM/YYYY') : '-'} {loading ? 'loading...' : details && details.start_time ? "(" + details.start_time + ")" : '-'}</span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>End Date & Time</p>
                                <span> {loading ? 'loading...' : details?.end_date ? moment(details.end_date).format('DD/MM/YYYY') : '-'} {loading ? 'loading...' : details && details.end_time ? "(" + details.end_time + ")" : '-'} </span>
                            </div>
                            <div className="mb-1">
                                <p>Venue</p>
                                <span> {loading ? 'loading...' : details && details.venue ? details.venue : '-'} </span>
                            </div>


                        </div>
                    </div>

                    <div className="col-12 mt-3 mt-lg-0 mt-md-0 col-md-6">
                        <div className="wrapper-admin training_details match_height">
                            <h6 className='text-center'>Live Session Information</h6>

                            <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
                                <p>Title</p>
                                <span> {loading ? 'loading...' : details && details.session_title ? details.session_title : '-'} </span>
                            </div>

                            <div className="mb-1">
                                <p>Meeting Link</p>
                                {/* <span> {loading ? 'loading...' : details && details.session_link ? details.session_link : '-'} </span> */}
                                {loading ? 'loading...' : details && details.session_link ? <a href={details?.session_link} target='_blank' className='text-primary'> {details?.session_link}</a> : '-'}
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Meeting ID</p>
                                <span> {loading ? 'loading...' : details && details.session_meeting_id ? details.session_meeting_id : '-'} </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <p>Meeting Password</p>
                                <span> {loading ? 'loading...' : details && details.session_password ? details.session_password : '-'} </span>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 mt-3">
                        {loading ?
                            <div className='wrapper-admin'>
                                <h5>Learning Module List</h5>
                                <div className='text-center mb-4'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                <h5>Learning Module List</h5>
                                {course_list && course_list.length ?
                                    <DataTables
                                        rowData={course_list}
                                        columnDefs={columnDefs_course}
                                        height={'40vh'}
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Learning Module List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </div>

                    {role !== 'Learner' ?
                        <div className="col-md-12 mt-3">
                            {loading ?
                                <div className='wrapper-admin'>
                                    <h5>User List</h5>
                                    <div className='text-center mb-4'>
                                        <PropagateLoader
                                            color="#2262C6"
                                            size={20}
                                        />
                                    </div>
                                </div>
                                :
                                <>
                                    <h5>User List</h5>
                                    {user_list && user_list.length ?
                                        <DataTables
                                            rowData={mergedArray}
                                            columnDefs={columnDefs_user}
                                            height={'40vh'}
                                            id={'page-size1'}
                                        />
                                        :
                                        <div className='wrapper-admin'>
                                            <div className='text-center'>
                                                <h5>User List Not Found</h5>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        : ''
                    }
                </div>
            </div>
        </>
    )
}
